/* eslint-disable indent */
import {thirdPartyTracking} from '@edreamsodigeo/frontend-tracking-agent';
const {
    identifyAnalyticsClient,
    createECommerceTrackingClient,
    createCustomDimensionsRepository,
    createThirdPartyTrackingAgent,
    trackGAPage,
    createTrackingParamsRepository,
} = thirdPartyTracking;

    const Fetcher = require('od-modules/utils/fetcher');

    function isAccommodationPostBookingFunnel() {
        const isPostBookingSession = Odigeo.Session && Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'));
        return isPostBookingSession || window.location.hash.indexOf('searchType=POST_BOOKING') !== -1;
    }

    var postBookingPages = [
        'xsellproductselection',
        'pbpayment',
        'flights_pay_page',
        'confirmation',
        'flights_confirmation_page',
        'flights_confirmation_page_confirmed',
        'flights_confirmation_page_rejected',
        'flights_confirmation_page_pending',
    ];

    function getWebmasterPageName() {
        var path = document.location.pathname.replace(Odigeo.Settings.getProperty('appContext'), '');
        return path.replace(/^\/+|\/+$/g, '');
    }

    function addPostBookingIfNecessary(page, text) {
        var isPostBookingPage = page === undefined || postBookingPages.indexOf(page) !== -1;
        var isAccommodationPostBooking = isAccommodationPostBookingFunnel();
        var isNotAdded = text === undefined ? -1 : text.indexOf('pb_') === -1;

        return isPostBookingPage && isAccommodationPostBooking && isNotAdded
            ? 'pb_' + text : text;
    }

    Odigeo.defineWidget('googleanalytics', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            currentVirtualPage: null,
            customDimensions: {},
            // correspondences between pages and category used in event tracking
            eventTrackingCategoryDictionary: {
                'home': {
                    '': 'home',
                    '/': 'home',
                    'home': 'home',
                    'flights/dates': 'home',
                    'flights/departure0': 'home',
                    'flights/departure1': 'home',
                    'flights/departure2': 'home',
                    'flights/departure3': 'home',
                    'flights/departure4': 'home',
                    'flights/departure5': 'home',
                    'flights/destination0': 'home',
                    'flights/destination1': 'home',
                    'flights/destination2': 'home',
                    'flights/destination3': 'home',
                    'flights/destination4': 'home',
                    'flights/destination5': 'home',
                    'flights/passengers': 'home',
                    'myinfo': 'static_myinfo',
                    'settings': 'static_settings',
                    'mytrips': 'static_mytrips',
                    'about': 'static_about',
                    'contact': 'static_contact',
                    'securedcontact': 'static_contact',
                    'masthead': 'static_masthead',
                    'terms': 'static_terms',
                    'error': 'static_error',
                    'header': 'header',
                    'register': 'sso_register',
                    'accountblocked': 'sso_blocked',
                    'resetpassword': 'sso_change_pwd',
                    'frequentpassengers': 'sso_frequent_passengers',
                    'accountcreditcards': 'sso_account_credit_cards',
                    'accountpreferences': 'sso_account_preferences',
                    'xsellproductselection': 'intermediate_page',
                    'xsellproductselectionmetas': 'intermediate_page_metas',
                    'android_app_layer': 'android_app_layer',
                    'iphone_app_layer': 'iphone_app_layer',
                    'filters': 'intermediate_page',
                },
                'dp': {
                    '': 'dynpack_tab',
                    '/': 'dynpack_tab',
                    'home': 'dynpack_tab',
                    'header': 'dynpack_tab',
                    'notification_center': 'dynpack_tab',
                    'sso_module': 'sso_module',
                    'dpresults_flights': 'dynpack_flight_results',
                    'dpresident': 'dynpack_residents_page',
                    'dpresults_accommodation_details': 'dynpack_room_selection',
                    'flights_results': 'dynpack_flight_results',
                    'details-extras': 'dynpack_pax_page',
                    'details': 'dynpack_pax_page',
                    'passengersinfo': 'dynpack_pax_page',
                    'payment': 'dynpack_pay_page',
                    'pbpayment': 'dynpack_pay_page',
                    'ancillaries': 'dynpack_ancillaries_page',
                    'selection': 'dynpack_ancillaries_page',
                    'additions': 'dynpack_additions_page',
                    'confirmation': 'dynpack_confirmation_page',
                    'flights_confirmation_page': 'dynpack_confirmation_page',
                    'flights_confirmation_page_confirmed': 'dynpack_confirmation_page_confirmed',
                    'flights_confirmation_page_rejected': 'dynpack_confirmation_page_rejected',
                    'flights_confirmation_page_pending': 'dynpack_confirmation_page_pending',
                    'flights_pax_page': 'dynpack_pax_page',
                    'flights_pay_page': 'dynpack_pay_page',
                    'flights_ancillaries_page': 'dynpack_ancillaries_page',
                    'flights_canxself_page': 'dynpack_canxself_page',
                    'flights_insurance_page': 'dynpack_insurance_page',
                    'flights_so_page': 'dynpack_so_page',
                    'dynpack_hotel_results': 'dynpack_hotel_results',
                    'dpresults_accommodation': 'dynpack_hotel_results',
                    'filters': 'dynpack_hotel_results',
                    'filter': 'dynpack_flight_results',
                    'insurance': 'dynpack_insurance_page',
                    'insurances': 'dynpack_insurance_page',
                    'booking': 'summary',
                    'servicepack': 'dynpack_so_page',
                },
                'flights': {
                    '': 'flights_tab',
                    '/': 'flights_tab',

                    /*
                     * Todo: SYRTOF-3409
                     * Refactor mobile.handler.home.js routers.
                     * Now when selecting city or date on mobile version
                     * Google analytics can't detect page category of the page.
                     * After refactoring delete the line below: 'flight': 'home'
                     */
                    'flights': 'home',

                    'home': 'flights_tab',
                    'header': 'flights_tab',
                    'notification_center': 'flights_tab',
                    'sso_module': 'flights_tab',
                    'xsellproductselection': 'intermediate_page',
                    'xsellproductselectionmetas': 'intermediate_page_metas',
                    'filters': 'intermediate_page',
                    'flightsummary': 'flights_summary',
                    'flightinfo': 'flights_info',
                    'insurance': 'flights_insurance_page',
                    'insurances': 'flights_insurance_page',
                    'flex': 'flights_flex_page',
                    'servicepack': 'flights_so_page',
                    'details-extras': 'flights_pax_page',
                    'results': 'flights_results',
                    'search_waiting': 'search_waiting',
                    'filter': 'flights_results',
                    'details': 'flights_pax_page',
                    'passengersinfo': 'flights_pax_page',
                    'ancillaries': 'flights_ancillaries_page',
                    'canx': 'flights_canxself_page',
                    'selection': 'flights_ancillaries_page',
                    'additions': 'flights_additions_page',
                    'payment': 'flights_pay_page',
                    'pbpayment': 'dynpack_pay_page',
                    'confirmation': 'flights_confirmation_page',
                    'flights_confirmation_page_confirmed': 'flights_confirmation_page_confirmed',
                    'flights_confirmation_page_rejected': 'flights_confirmation_page_rejected',
                    'flights_confirmation_page_pending': 'flights_confirmation_page_pending',
                    'resident': 'flights_residents_page',
                    'android_app_layer': 'android_app_layer',
                    'iphone_app_layer': 'iphone_app_layer',
                    'my_area_trips': 'my_area_trips',
                    'my_area_trips_details': 'my_area_trips_details',
                    'trip_summary': 'trip_summary',
                    'accommodation_details': 'intermediate_room_selection',
                    'flights_results': 'flights_results',
                    'dpresults_accommodation_details': 'room_selection',
                },
                'cms': {
                    '': getWebmasterPageName(),
                    '/': getWebmasterPageName(),
                    'home': getWebmasterPageName(),
                },
                'trackingTool': {
                    'home': 'home',
                    '/vuelos/': 'flights',
                    'resident': 'resident',
                    'results': 'results',
                    'payment': 'payment',
                    'details': 'details',
                    'flights/waiting/1': 'waitresults',
                    'flights/waiting/2': 'waitpassengers',
                    'flights/waiting/3': 'waitpayment',
                    'flights/waiting/4': '',
                    'flights/waiting/5': 'waitconfirmation',
                    'sm/flights/waiting/1': 'waitresults',
                    'sm/flights/waiting/2': '', // mobile waiting flight summary
                    'sm/flights/waiting/3': '', // mobile wait for details
                    'sm/flights/waiting/4': 'waitpassengers',
                    'sm/flights/waiting/5': 'waitpayment',
                    'sm/flights/waiting/6': 'waitconfirmation',
                    'details-extras': 'passengers',
                    'payment3ds': 'payment3ds',
                    '/flights/dates/': 'flightdates',
                    'confirmation': 'confirmation',
                    '/flights/departure0/': 'departure0',
                    '/flights/departure1/': 'departure1',
                    '/flights/departure2/': 'departure2',
                    '/flights/departure3/': 'departure3',
                    '/flights/departure4/': 'departure4',
                    '/flights/departure5/': 'departure5',
                    '/flights/destination0/': 'destination0',
                    '/flights/destination1/': 'destination1',
                    '/flights/destination2/': 'destination2',
                    '/flights/destination3/': 'destination3',
                    '/flights/destination4/': 'destination4',
                    '/flights/destination5/': 'destination5',
                    '/flights/passengersSelection/': 'passengers',
                    'summary': 'flightsummary',
                    'flightinfo': 'flightinfo',
                    'insurances': 'insurances',
                    '/flights/insurances/conditions': 'insuranceconditions',
                    'filter': 'filter',
                    'edit': 'home',
                    // Not implemented on TrackingTool yet
                    'register': '',
                    'dynpack/waiting/1': '',
                    'dynpack/waiting/3': '',
                    'dynpack/waiting/4': '',
                    'dynpack/waiting/5': '',
                    'dynpack/waiting/2': '',
                    'room-selection': '',
                    'roomselection': '',
                    'dpresults_accommodation_details': '',
                },
            },

            pageVirtualApplicationDictionary: {
                '': 'home',
                'checkout_flight_summary_results': 'results',
                'checkout_flight_summary_meta': 'flightsummary',
                'dpresident': 'resident',
                'roomselection': 'room-selection',
                'dpresults_accommodation_details': 'room-selection',
                'flex': 'flex_page',
                'canx': 'cancellation-guarantee',
                'ancillaries/canx': 'cancellation-guarantee',
                'ancillaries/selection': 'ancillaries',
                'ancillaries/additions': 'additions',
                'bestprices': 'results',
            },

            // contains all virtual pages that should have /flights/ prefix when they are tracked
            appPages: ['', '/', 'home', 'native-search', 'flights', 'results', 'flights-results', 'hotel-results', 'room-selection',
                'edit', 'flights-filter', 'hotel-filter', 'summary', 'flightinfo', 'dp-upsell', 'dp-upsell-meta', 'cancellation-guarantee',
                'flex_page', 'insurances', 'service_options', 'additions_page', 'details-extras', 'details', 'passengersinfo', 'payment',
                'confirmation', 'resident', 'redirection-3dsecure', 'ancillaries', 'prime', 'bestprices', 'checkout_flight_summary_results',
                'checkout_flight_summary_meta', 'checkout', 'hotels_upsell', 'upsell'],

            // Initialize Google Analytics Universal
            init: function() {
                this.options = Odigeo.parseOptions(this.widget.options);
            },

            // eCOMMERCE TRACKING
            createECommerceData: function(data) {
                return {
                    transaction: data.transactionUniversal,
                    products: [
                        ...(data.flightItemsUniversal || []),
                        ...(data.dynpackItemsUniversal || []),
                        ...(data.insuranceItemsUniversal || []),
                        ...(data.ancillaryItemsUniversal || []),
                        ...(data.membershipItemsUniversal || []),
                    ],
                };
            },

            trackECommerce: function(data) {
                if (data !== null && data.fakeTransaction === false) {
                    const eCommerceClient = createECommerceTrackingClient();
                    const eCommerceData = this.createECommerceData(data);
                    eCommerceClient.trackEvent(eCommerceData);
                }
            },

            // EVENT TRACKING
            /**
             * @function
             * @param {object} data
             * @param {object} data.category on dp product is a hash to access category name by eventTrackingCategoryDictionary
             * @param {object} data.action
             * @param {object} data.label
             * @param {object} data.page (optional) This property is used when GAP category parameter
             * @param {object} data.value (optional) A value of undefined ignores the option. See link below.
             * should be determined based in the page where event occurs
             * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiEventTracking#_gat.GA_EventTracker_._trackEvent
             */
            trackEvent: function(data) {
                const thirdPartyTrackingAgent = createThirdPartyTrackingAgent({});
                const app = Odigeo.Utils.isWebmasterPage() ? 'cms' : Odigeo.Utils.getAppInGlobalScope();
                const category = this._getCategory(data, app);
                const label = this._getLabel(data);
                const action = data.action;
                const page = this.currentVirtualPage;
                const dimensionsAndParams = {...this.customDimensions, ...this.buyPathDimension};
                thirdPartyTrackingAgent.trackEvent({page, category, action, label, dimensionsAndParams});
            },

            processMetasPage: function(data) {
                const suffix = !(Odigeo.Session.get('isMetaForIntermediate') === null
                    || Odigeo.Session.get('isMetaForIntermediate') === '') ? 'metas' : '';
                return (data.page === 'xsellproductselection') ? data.page + suffix : data.page;
            },

            _getLabel: function(data) {
                let label = data.label;
                var page = this.processMetasPage(data);
                page = page ? page : data.category;

                if (data.appendPageLabel) {
                    label = `${label}_pag:${this._getCategory(data, Odigeo.Utils.getAppInGlobalScope())}`;
                }
                return addPostBookingIfNecessary(page, label);
            },

            /**
             * It calculates category based on app, data.page and data.category
             * @function
             * @param {object} data
             * @param {object} app
             * @return {string}
             */
            _getCategory: function(data, app) {
                app = app === 'upsell' ? 'dp' : app;
                var page = this.processMetasPage(data);
                let response;
                if (app === 'dp' && data.category !== undefined) {
                    response = this.eventTrackingCategoryDictionary[app][data.category];
                } else if (page !== undefined && this.eventTrackingCategoryDictionary[app] !== undefined) {
                    response = this.eventTrackingCategoryDictionary[app][page];
                } else {
                    response = data.category;
                }
                let category = response !== undefined ? response : data.category;

                return addPostBookingIfNecessary(page, category);
            },

            /**
             * @function
             * @param {object} data
             * @param {object} data.url
             */
            sendToPageSelf: function(data) {
                let url = data.url;
                data.goOutside = (data.goOutside !== undefined) ? (this.prepareLinkToTrackCrossDomain(url) !== url) : data.goOutside;
                if (data.goOutside) {
                    document.location = url;
                } else {
                    document.location = data.url;
                }
            },

            /**
             * @function
             * @param {object} data
             * @param {object} data.url
             */
            sendToPageBlank: function(data) {
                if (data.goOutside) {
                    window.open(this.prepareUrlToTrackCrossDomain(data.url));
                } else {
                    window.open(data.url);
                }
            },


            isWaitingPage: function(page) {
                return /^waiting(\/\d|-3dsecure)$/g.test(page);
            },

            _getFunnel: function(page, funnelParam) {
                var isPostBookingAccommodation = isAccommodationPostBookingFunnel();
                var isAccommodationFlow = Odigeo.Router.getCurrentApp() === 'accommodation';
                var isNativeSearchFlow = Odigeo.Router.getCurrentApp() === 'home-accommodation';
                var funnelInGlobalScope =
                    isPostBookingAccommodation || isAccommodationFlow || isNativeSearchFlow ? 'hotels' : Odigeo.Utils.getFunnelInGlobalScope();
                var isWebmasterPage = Odigeo.Utils.isWebmasterPage();
                var isAppPages = this.appPages.includes(page) && funnelInGlobalScope !== undefined;
                var hardFunnel = (typeof funnelParam === 'string' && funnelParam !== '') && funnelParam;
                var defaultFunnel = funnelParam === true && 'flights';
                var scopeFunnel = !isWebmasterPage && (isAppPages || this.isWaitingPage(page)) && funnelInGlobalScope;

                var funnel = hardFunnel || scopeFunnel || defaultFunnel;

                return funnel ? funnel + '/' : '';
            },

            _getPage: function(data) {
                if (Odigeo.Utils.isWebmasterPage()) {
                    return getWebmasterPageName();
                } else {
                    return this.pageVirtualApplicationDictionary[data.page] || data.page;
                }
            },

            // VIRTUAL PAGES TRACKING
            /**
             * @function
             * @param {object} data
             * @param {object} data.funnel Boolean. Indicates if virtual page belongs to funnel or not
             * @param {object} data.page String that represents page name
             * @param {object} data.error This property is present only if an error ocurred into tracked page
             * @param {object} data.error.type 2 error types have been considered: popin (when a dialog appear) and default
             * @param {object} data.error.message Error message to be tracked
             * @param {object} data.customVar (optional) Track this page using a non default customVar.
             *                 After tracking is done, default customVar is set again.
             */
            trackVirtualPage: function(data) {
                this.trackVirtualPageInUniversal(data);
                this.trackInTrackingTool(data);
            },

            getFunnelPrefix: function() {
                return isAccommodationPostBookingFunnel() ? '/PB' : '/BF';
            },

            _generatePageviewUniversal: function(data) {
                const funnelPrefix = data.funnel ? this.getFunnelPrefix() : '';
                const page = this._getPage(data);
                const funnelPage = this._getFunnel(page, data.funnel);
                const errorPage = data.error ? 'error/' : '';
                const virtualError = data.error !== undefined
                    ? data.error.type === 'popin'
                        ? '-popin-error'
                        : '_error_' + data.error.message
                    : '';

                return (funnelPrefix + '/' + funnelPage + errorPage + page + virtualError + '/').replace(/\/{2,}/g, '/');
            },

            callAnalyticsClientIdentificationService: function() {
                identifyAnalyticsClient();
            },

            trackVirtualPageInUniversal: function(data) {
                const virtualPage = this._generatePageviewUniversal(data);
                this.currentVirtualPage = virtualPage;
                if (data.eCommerce) {
                    const transactionPrice = data.eCommerce.customMetrics && data.eCommerce.customMetrics.metric8;
                    this.customDimensions = {...this.customDimensions, ...data.eCommerce.customMetrics, transaction_price: transactionPrice};
                    this.trackECommerce(data.eCommerce);
                }
                const options = {
                    customDimensions: {...this.customDimensions, ...data.customDimensions},
                    error: data.error,
                    eCommerce: data.eCommerce,
                    funnel: data.funnel,
                };
                trackGAPage(virtualPage, options);
            },

            trackInTrackingTool: function(data) {
                var isMobile = Odigeo.SessionScope.flow === 'mobile';
                var toolPageName = this._getPageNameForTrackingTool(data.page, isMobile);
                var serviceUrl = Odigeo.Settings.options.trackingToolServiceFormatter('trackPageView') + '/' + toolPageName;

                if (toolPageName) {
                    Fetcher.get(serviceUrl).text();
                }
            },

            _getPageNameForTrackingTool: function(page, isMobile) {
                var word;
                var dictionary = this.eventTrackingCategoryDictionary['trackingTool'];
                // Los indices de la waiting para mobile y desktop son diferentes
                if (isMobile && page.indexOf('waiting') > -1) {
                    word = dictionary['sm/' + page];
                } else {
                    word = dictionary[page];
                }
                return word || '';
            },

            setCustomDimension: function(params) {
                const customDimensionsRepository = createCustomDimensionsRepository();
                customDimensionsRepository.set(params);
            },

            trackCustomVariable: function(params) {
                if (params.customDimension) {
                    this.setCustomDimension(params);
                }
            },

            trackPromo: function(_data) { },

            /**
             * @function
             * @description This method works in conjunction with the _setDomainName() and _setAllowLinker()
             * methods to enable cross-domain user tracking
             * specifically for iFrames and links that open in a new window.
             * This method returns a string of all the
             * <a href="https://developers.google.com/analytics/resources/concepts/gaConceptsCookies">GATC cookie</a>
             * data from the initiating link by appending it to the URL parameter.
             * This can then be passed on to a another site or iFrame.
             * @param {string} url
             * @return {string} url with GATC cookide data appended.
             */
            prepareUrlToTrackCrossDomain: function(url) {
                return url;
            },

            prepareLinkToTrackCrossDomain: function(url) {
                var mainDomain = this.options.mainDomain;
                var linkDomain = this.extractDomain(url);
                var crossDomainExceptions = this.options.crossDomainExceptions;
                var crossDomainExceptionsArray = Array.isArray(crossDomainExceptions) ? crossDomainExceptions : [crossDomainExceptions];

                return (mainDomain !== linkDomain && !crossDomainExceptionsArray.includes(linkDomain)) ?
                    this.prepareUrlToTrackCrossDomain(url) : url;
            },

            extractDomain: function(url) {
                var domain;
                domain = ((url.indexOf('://') > -1) ? url.split('/')[2] : url.split('/')[0]).split(':')[0];
                return (domain.indexOf('www') > -1) ? domain.split('www.')[1] : domain;
            },

            addCrossDomainIframeTracking: function(_iFrame) { },

            getMktportalParams: function() {
                return {mktportal: Odigeo.SessionScope.mktPortal || ''};
            },

            decorateAppTouchpointUrl: function(url) {
                const trackingParamsRepository = createTrackingParamsRepository();
                const utmParams = trackingParamsRepository.getUtmParams();
                var params = {
                    ...utmParams,
                    ...this.getMktportalParams(),
                };

                var paramStr = Object.entries(params).map(([key, value]) => {
                    return `${key}=${value}`;
                }).join('&');

                return url.replace('{TRACKING_PARAMS}', encodeURIComponent(paramStr));
            },

        }),

        exposedMethods: [
            'trackEvent',
            'sendToPageSelf',
            'sendToPageBlank',
            'trackECommerce',
            'trackVirtualPage',
            'trackCustomVariable',
            'setCustomDimension',
            'trackPromo',
            'prepareUrlToTrackCrossDomain',
            'prepareLinkToTrackCrossDomain',
            'addCrossDomainIframeTracking',
            'decorateAppTouchpointUrl',
        ],

        execute: function(fn) {
            var result;
            if (this.exposedMethods.includes(fn) && typeof this.model[fn] === 'function') {
                var args = [].slice.call(arguments, 1);
                result = this.model[fn].apply(this.model, args);
            }
            return result !== undefined ? result : this;
        },

        getUrlDecoratedWithCrossDomainParameters: function(link) {
            return this.model.prepareLinkToTrackCrossDomain(link);
        },

        getDecoratedAppTouchpointUrl: function(url) {
            return this.model.decorateAppTouchpointUrl(url);
        },
    }));
